/**
 * Salva um item no sessionStorage
 * @param key - A chave para o item a ser armazenado
 * @param value - O valor do item a ser armazenado
 */
export const saveToSessionStorage = (key: string, value: any): void => {
    try {
        const serializedValue = JSON.stringify(value)
        sessionStorage.setItem(key, serializedValue)
    } catch (error) {
        console.error('Erro ao salvar no sessionStorage', error)
    }
}

/**
 * Obtém um item do sessionStorage
 * @param key - A chave para o item a ser recuperado
 * @returns O valor do item armazenado ou null se a chave não existir
 */
export const getFromSessionStorage = (key: string): any => {
    try {
        const serializedValue = sessionStorage.getItem(key)
        if (serializedValue === null) {
            return null
        }
        return JSON.parse(serializedValue)
    } catch (error) {
        console.error('Erro ao obter do sessionStorage', error)
        return null
    }
}

/**
 * Remove um item do sessionStorage
 * @param key - A chave para o item a ser removido
 */
export const removeFromSessionStorage = (key: string): void => {
    try {
        sessionStorage.removeItem(key)
    } catch (error) {
        console.error('Erro ao remover do sessionStorage', error)
    }
}

/**
 * Limpa todos os itens do sessionStorage
 */
export const clearSessionStorage = (): void => {
    try {
        sessionStorage.clear()
    } catch (error) {
        console.error('Erro ao limpar o sessionStorage', error)
    }
}
